import { render, staticRenderFns } from "./ChapterItem.vue?vue&type=template&id=3fd87c7e&"
import script from "./ChapterItem.vue?vue&type=script&lang=js&"
export * from "./ChapterItem.vue?vue&type=script&lang=js&"
import style0 from "./ChapterItem.vue?vue&type=style&index=0&id=3fd87c7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports